import gql from 'graphql-tag';

import { PLEX_OVERVIEW_FRAGMENT } from '../fragments/Plex/plexOverview';

export const GET_PLEX_OVERVIEW_QUERY = gql`
  query GetPlexOverview($plexId: String!) {
    loggedIn {
      plexById(id: $plexId) {
        ...plexOverview
      }
    }
  }

  ${PLEX_OVERVIEW_FRAGMENT}
`;

export { useGetPlexOverviewQuery } from '../gen/types';
